var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog", "aria-hidden": "true" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-xl modal-dialog-scrollable",
          attrs: { role: "document" }
        },
        [
          _vm.equipment
            ? _c("div", { staticClass: "modal-content" }, [
                _c(
                  "div",
                  { staticClass: "modal-header" },
                  [
                    _vm.editable
                      ? [
                          !_vm.equipment.id
                            ? _c("h5", { staticClass: "modal-title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "testEquipment.editmodal.newEqipment"
                                    )
                                  )
                                )
                              ])
                            : _c("h5", { staticClass: "modal-title" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "testEquipment.editmodal.editEqipment"
                                      )
                                    )
                                )
                              ])
                        ]
                      : _c("h5", { staticClass: "modal-title" }, [
                          _vm._v(_vm._s(_vm.$t("testEquipment.editmodal.name")))
                        ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button", "aria-label": "Close" },
                        on: { click: _vm.dismiss }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c("TestEquipmentEdit", {
                      attrs: {
                        equipment: _vm.equipment,
                        tests: _vm.tests,
                        editable: _vm.editable,
                        showArchiveFields: _vm.showArchiveFields
                      },
                      on: {
                        save: _vm.save,
                        "file-added": function($event) {
                          return _vm.$emit("file-added", $event)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.dismiss }
                    },
                    [_vm._v(_vm._s(_vm.$t("testEquipment.editmodal.close")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button", disabled: !_vm.canSave },
                      on: { click: _vm.save }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("testEquipment.editmodal.save")) +
                          "\n        "
                      )
                    ]
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }